import React from 'react';
import { NavLink } from 'react-router-dom';
import { Translate } from 'react-localize-redux';

const ScheduleWeekItem = (props) => {
    return (

        <NavLink className="btn btn-primary  btn-scheduleWeek jsSelectWeek" to={`/Schedule/Weekly/${props.item.weekNo}`}>
                 <span class="schedule_weekno"> <Translate id="general.Week"/> {props.item.weekNo}</span>
                {/* <span class=" d-sm-block d-none Week schedule_weekdate">{props.item.from} - {props.item.to}</span> */}
                
                {/* <span class="d-sm-none d-block">{props.item.from} <br /> {props.item.to}</span> */}
      
        </NavLink>
    );
};

export default ScheduleWeekItem;


// WEBPACK FOOTER //
// ./src/pages/student_schedule/ScheduleWeekItem.js